module.exports = __webpack_public_path__ + "images/emoji/rice_scene.e6b8c0734847c2609bcb.png";